<template>
    <cr-confirmation-dialog v-bind="$attrs" class="confirmation-dialog" :title="title" :persistent="persistent" :cancel="false" :confirm="false" :data-testing="dataTesting" @confirm="onConfirm" @cancel="onCancel">
        <slot />
        <template #footerRight>
            <cr-button background-color="cr-confirmation-dialog-confirm-background-color" text-color="cr-confirmation-dialog-confirm-text-color" :disabled="disabled" data-testing="confirmation-dialog-confirm">
                {{ confirmText || t('CONFIRMATION_DIALOG_CONFIRM') }}
            </cr-button>
            <cr-button v-if="cancel" text type="button" :disabled="disabled" @click="onCancel" data-testing="confirmation-dialog-cancel">
                {{ cancelText || t('CONFIRMATION_DIALOG_CANCEL') }}
            </cr-button>
        </template>
    </cr-confirmation-dialog>
</template>

<style>
.confirmation-dialog .cr-confirmation-dialog-form-instruction,
.confirmation-dialog .cr-checkbox label,
.confirmation-dialog .cr-checkbox .cr-required-indicator
{
    --cr-input-required-indicator-color: white;
    color: white;
}
</style>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

withDefaults(defineProps<
{
    title?: string;
    persistent?: boolean;
    confirmText?: string;
    cancelText?: string;
    cancel?: boolean;
    disabled?: boolean;
    dataTesting?: string;
}>(),
{
    title: undefined,
    persistent: false,
    confirmText: undefined,
    cancelText: undefined,
    cancel: true,
    disabled: false,
    dataTesting: 'confirmation-dialog'
});

const emit = defineEmits<{
    (e: 'confirm'): void;
    (e: 'cancel'): void;
}>();

const onConfirm = () => emit('confirm');
const onCancel = () => emit('cancel');
</script>
